import axios from "axios";

const apiClient = axios.create({
  baseURL: import.meta.env.VITE_API_URL ?? "" + "/api", // Base URL dal file di configurazione
  headers: {
    "Content-Type": "application/json", // Header per indicare il tipo di contenuto
    Accept: "application/json", // Accettare solo JSON come risposta
    "x-requested-with": "XMLHttpRequest", // Intestazione aggiunta
    referr: "Access-Control-Allow-Origin",
  },
});

// Interceptor per debug/errori (opzionale)
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error("API Error:", error);
    return Promise.reject(error);
  }
);

export default apiClient;
